import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ArrowLeft } from "lucide-react";
import { ReferenceForm } from "../components";
import { useCreateReference } from "../hooks/useCreateReference";
import { useMe } from "../../users/hooks/useMe";

export const CreateReference: React.FC = () => {
  const navigate = useNavigate();
  const { data: userData } = useMe();

  const { form, submit, loading } = useCreateReference({
    defaultValues: {
      name: "",
      url: "",
      imgUrl: "",
      reference: "",
      lastPrice: 0,
      lastQuantity: 0,
      userId: userData?.me?.id || 0,
    },
    onCompleted: (id) => {
      toast.success("La référence a été créée avec succès");
      navigate("/references");
    },
    onError: (msg) => toast.error(msg),
  });

  return (
    <div className="main-container">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-white shadow-sm border-b border-gray-200 mb-4 -mx-4 px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/references")}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeft size={20} className="text-gray-600" />
            </button>
            <div>
              <h1 className="text-xl font-bold text-gray-900">
                Nouvelle Référence
              </h1>
              <p className="text-sm text-gray-500 mt-1">
                Créer une nouvelle référence de produit
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Form */}
      <ReferenceForm loading={loading} submit={submit} form={form} />
    </div>
  );
};
